import React, { useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';

const BenefitsWebsite = props => {
  const slider = useRef();

  const settings = {
    infinite: true,
    speed: 300,
    swipe: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrow: false,
    autoplay: true,

    responsive: [
      {
        breakpoint: 767,
        settings: {
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          swipe: true,
          arrows: false,
          dots: true,
          dotsClass: 'custom-dots',
          centerMode: true,
          centerPadding: '15px',
        },
      },
    ],
  };

  return (
    <>
      <style>{`
             .slick-list:first-of-type,for-hover:first-of-type{
                padding-left:0!important
              }
             .slick-slide {
                outline: none
              }
              .slick-slide div {
                 outline: none
              }
              .slick-slide:focus,.slick-slide a{
                outline: none;
              }
              .shadow-new{
                box-shadow: 0px 1px 3px 1px rgb(0 0 0 / 7%);
                border-radius: 0px 0px 25px 25px;
              }
              .shadow-new-w{
                box-shadow: 0px 1px 6px 1px rgb(0 0 0 / 7%);
              }
              .custom-dots{
                display:flex!important;
                justify-content:center;
              }
              .custom-dots li{
                position:relative;
                margin:0 3px;
                margin-top:20px;
                width:50px;
                height:2px;
                background-color: #C4C4C4;
                overflow:hidden;
              }
              .custom-dots li.slick-active{
                background-color:#670F7A;
              }
              .custom-dots li button{
                position:absolute;
                width:100%;
                height:100%;
                top:0;
                left:0;
                opacity:0;
              }`}</style>

      <Slider ref={slider} {...settings} className="relative z-10 pt-24   ">
        <div className={'w-30p block pr-15'}>
          <h3 className={'text-green font-bold text-24 leading-29 mb-14'}>Increased Website Traffic</h3>
          <div className={' border-gray-dark border-r-0 md:border-r-1'}>
            <div className={'pr-0 md:pr-30'}>
              Website explainer video production helps your website rank higher in search engine results pages. Impactful videos provide rich
              multimedia content to your website. Therefore, leading to higher visibility and more organic traffic. Make a site explainer animation,
              live action or mixed media, pick the most suitable style. The video format will make the website as useful as possible.
            </div>
          </div>
        </div>
        <div className={'w-30p block pr-15'}>
          <h3 className={'text-green font-bold text-24 leading-29 mb-14  px-0 md:px-30 '}>Higher Engaging Solution</h3>
          <div className={'w-full  border-gray-dark border-r-0 md:border-r-1'}>
            <div className={' px-0 md:px-30 '}>
              With an explainer video, the website gives an eye-catching impact and clear understanding of a product to your customers. The
              opportunity to appear on your website from different platforms guarantees the engagement of new customers and improves website’s SEO
              performance.
            </div>
          </div>
        </div>
        <div className={'w-30p block pl-0 md:pl-30 pr-15'}>
          <h3 className={'text-green font-bold text-24 leading-29 mb-14'}>Explanation Simplifying Filter</h3>
          Turn your explanations into engaging videos, instead of writing long paragraphs. Website explainer video production will pick the main
          information. Filtering complex ideas will give straight introductions. Aalso, all the information is available in one place.
        </div>
      </Slider>
    </>
  );
};
export default BenefitsWebsite;
